/**
 * @iqmaxx/shared — DDD-structured shared types
 *
 * Layer exports:
 * - kernel: Enums, base types, value objects (no domain dependencies)
 * - core: Identity & Access types (platform-level)
 * - verticals/iqmax: Education marketplace types
 * - contracts: Extension point interfaces (future)
 */

// Kernel — foundation types
export * from './kernel';

// Core — Identity & Access bounded context
export * from './core/identity-access';

// Verticals — IQMax education vertical
export * from './verticals/iqmax';

// Auth types (kept for backwards compatibility)
export * from './types/auth.types';

// API request/response types (kept for backwards compatibility)
export * from './types/api.types';
